export default function setOpeningDateString(pDate, lang) {
    let theDate = new Date(pDate),
        today = new Date(),
        day = theDate.getDate(),
        month = theDate.getMonth() + 1, // Monate sind von 0-11, also +1
        year = theDate.getFullYear();

    // Überprüfung, ob das Datum in der Vergangenheit liegt
    if (theDate < today) {
        return false;
    }

    return day + '.' + month + '.' + year;

    if(lang === 'en') {
        if (day > 3 && day < 21) return 'th';
        switch (day % 10) {
            case 1:  
                day+= "st ";
                break;
            case 2:  
                day+= "nd ";
                break;
            case 3:  
                day+= "rd ";
                break;
            default: 
                day+= "th ";
                break;
        }
    }else{
        day+= '. ';
    }
    return day+new Date(pDate).toLocaleDateString(lang, { month: 'short', year: 'numeric'});
  }
  